(function (root) {
  'use strict';
  const PLATE_IDS = [9681574166796, 9682185093388, 8726004695308, 9684666745100, 11543072637196];
  function quantity(value) {
    const n = Number(value);
    return Number.isSafeInteger(n) && n >= 1 ? n : null;
  }
  function plateTotal(value) {
    const n = quantity(value);
    if (!n || n > 10) return null;
    if (n === 10) return 38995;
    return n * (n >= 5 ? 4399 : 5995);
  }
  function plateCount(items) {
    return items.reduce((sum, item) => sum + (PLATE_IDS.includes(Number(item.product_id ?? item.productId)) ? Number(item.quantity) || 0 : 0), 0);
  }
  function quoteUrl(number, items, intro, shopUrl) {
    const phone = /^\d{7,15}$/.test(String(number)) ? String(number) : '4915222614897';
    const lines = [intro || 'Hallo GPlate, bitte erstellt mir ein individuelles Angebot für folgende Auswahl:', ''];
    for (const item of items) {
      const variant = item.variant_title ?? item.variant ?? '';
      lines.push(`${item.quantity} × ${item.product_title ?? item.title}${variant && variant !== 'Default Title' ? ' – ' + variant : ''}`);
      const properties = Array.isArray(item.properties) ? item.properties : Object.entries(item.properties || {});
      for (const [name, value] of properties) {
        if (name[0] !== '_' && value) lines.push(`${name}: ${value}`);
      }
      if (item.url) lines.push(new URL(item.url, shopUrl || 'https://gplate.de').href);
      lines.push('');
    }
    lines.push('Mein Unternehmen:', 'Gewünschter Lieferort:');
    return `https://wa.me/${phone}?text=${encodeURIComponent(lines.join('\n'))}`;
  }
  const rules = Object.freeze({ PLATE_IDS, quantity, plateTotal, plateCount, quoteUrl });
  if (typeof module !== 'undefined' && module.exports) module.exports = rules;
  else root.GPlateRules = rules;
})(typeof window !== 'undefined' ? window : globalThis);
